import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Grid, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { useContext } from 'react';
import { NewBookingContext } from '../NewBookingContext';
import { DurationDay } from './DurationDay';
export const AddAbsenceMultipleDayPage = ({ duration, }) => {
    const { dateRange, updateState } = useContext(NewBookingContext);
    const onStartDate = (newDate) => {
        updateState((state) => ({
            ...state,
            dateRange: { ...state.dateRange, startDate: newDate },
        }));
    };
    const onEndDate = (newDate) => {
        updateState((state) => ({
            ...state,
            dateRange: { ...state.dateRange, endDate: newDate },
        }));
    };
    return (_jsxs(Grid, { container: true, p: 2, spacing: 1, width: '100%', children: [_jsx(Grid, { item: true, xs: 12, display: 'flex', gap: 1, pb: 2, children: _jsx(DurationDay, { duration: duration }) }), _jsx(Grid, { item: true, xs: 12, md: 12, children: _jsx(LocalizationProvider, { dateAdapter: AdapterMoment, children: _jsxs(Box, { display: 'flex', gap: 1, children: [_jsx(DatePicker, { OpenPickerButtonProps: {
                                    id: 'add-absence-start-date-picker',
                                }, label: "Start date", value: dateRange.startDate, onChange: onStartDate, inputFormat: 'DD/MM/YYYY', renderInput: (props) => _jsx(TextField, { ...props }) }), _jsx(DatePicker, { OpenPickerButtonProps: {
                                    id: 'add-absence-end-date-picker',
                                }, renderInput: (props) => _jsx(TextField, { ...props }), label: "End date", value: dateRange.endDate, onChange: onEndDate, inputFormat: 'DD/MM/YYYY', defaultCalendarMonth: dateRange.startDate })] }) }) })] }));
};
